// These are done here to avoid circular dependencies. This is called at the
// very top of the BlinkSDK constructor, so it's still safe to assume they
// are available at all points throughout the code.

import {merchantBuiltinFunctions} from "./Builtins.js";
import {isURLViewed} from "../user-journey/conditions/Helpers.js";
import {getQueryParam, isSmallScreen} from "../../../blinkpay/UtilsLib.js";
import {merchantVariableModule} from "./MerchantVariableModule.js";
import {getCookie, setCookie} from "../../utils/cookie.js";
import {panelModule} from "../PanelModule.js";
import {runBlinkAction} from "../user-journey/engine/JourneyActionRunner.js";
import {editPanel} from "../../PanelOptionsLogic";

export function initMerchantBuiltinFunctions() {
    Object.assign(merchantBuiltinFunctions, {
        chooseRandom: (values) => {
            return values && values[Math.floor(values.length * Math.random())];
        },
        isURLViewed,
        isSmallScreen,
        getQueryParam,
        setCookie,
        getCookie,
        getVariable: (key) => merchantVariableModule.get(key),
        hasVariable: (key) => merchantVariableModule.has(key),
        setVariable: (key, value, scope) => merchantVariableModule.set(key, value, scope),
        deleteVariable: (key) => merchantVariableModule.delete(key),
        addVariables: (variables) => merchantVariableModule.add(variables),
        createPanel: (options, journey) => {
            const {loop, selector} = options;
            options = {
                ...options,
            };
            if (journey) {
                options.journeyId = journey.id;
                options.journeyAlias = journey.alias;
            }
            delete options.loop;
            if (loop) {
                panelModule.addRule(options);
            } else {
                delete options.selector;
                panelModule.createPanel(selector, options);
            }
        },
        editPanel: (options) => editPanel(options.panel, {
            ...options,
            panel: undefined,
        }),
        runBlinkAction,
    });
}
